import { Controller } from "@hotwired/stimulus"
import { enter } from "el-transition";

export default class extends Controller {
    static targets = ["snackBarContainer", "snackBar", "loadingBar"]

    connect() {
        this.showSnackBar();
    }

    disconnect() {
        this.cancelLoadingBarAnimation();
    }

    showSnackBar() {
        this.snackBarTarget.classList.remove("hidden");
        enter(this.snackBarTarget);
        const disappearAfterSeconds = Number(
            this.snackBarContainerTarget.getAttribute('data-disappear-after-seconds')
        );

        if (Number.isFinite(disappearAfterSeconds) && disappearAfterSeconds > 0) {
            // Start the loading bar animation
            this.animateLoadingBar(disappearAfterSeconds, () => {
                this.hideSnackBar();
            });
        }
    }

    animateLoadingBar(durationInSeconds, onComplete) {
        this.cancelLoadingBarAnimation();

        const loadingBar = this.loadingBarTarget;
        let startTime = null;
        const totalDuration = durationInSeconds * 1000;

        const animate = (currentTime) => {
            if (startTime === null) {
                startTime = currentTime;
            }

            const elapsedTime = currentTime - startTime;
            const progress = Math.min(elapsedTime / totalDuration, 1); // Ensure progress does not exceed 1

            const width = 100 * (1 - progress);
            loadingBar.style.width = `${width}%`;

            if (progress < 1) {
                this.loadingBarAnimationFrame = requestAnimationFrame(animate);
            } else if (typeof onComplete === 'function') {
                this.loadingBarAnimationFrame = null;
                onComplete();
            }
        }

        this.loadingBarAnimationFrame = requestAnimationFrame(animate);
    }

    cancelLoadingBarAnimation() {
        if (this.loadingBarAnimationFrame) {
            cancelAnimationFrame(this.loadingBarAnimationFrame);
            this.loadingBarAnimationFrame = null;
        }
    }

    hideSnackBar() {
        this.cancelLoadingBarAnimation();
        this.element.remove();
    }
}
